import { render, staticRenderFns } from "./BtnInserirProcesso.vue?vue&type=template&id=26eda16d&"
import script from "./BtnInserirProcesso.vue?vue&type=script&lang=js&"
export * from "./BtnInserirProcesso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports